import { motion } from "framer-motion";
import { Film, Camera, PenTool, ArrowUpRight } from "lucide-react";

const cards = [
  {
    id: "video_service",
    title: "Videography",
    label: "Motion",
    icon: Film,
    img: "https://images.unsplash.com/photo-1589976584421-86fda88fa33a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    desc: "Brand films, music videos, weddings and events shot on high-end cinema cameras.",
    span: "md:col-span-8 md:row-span-2",
    tall: true,
  },
  {
    id: "photography",
    title: "Photography",
    label: "Stills",
    icon: Camera,
    img: "https://images.unsplash.com/photo-1576280314550-773c50583407?crop=entropy&cs=srgb&fm=jpg&w=1000&q=80",
    desc: "Portrait, product and editorial photography with a cinematic edge.",
    span: "md:col-span-4",
  },
  {
    id: "class_graphic",
    title: "Graphic & Brand Design",
    label: "Identity",
    icon: PenTool,
    img: "https://images.pexels.com/photos/8100060/pexels-photo-8100060.jpeg?auto=compress&cs=tinysrgb&w=1000",
    desc: "Logos, brand systems and websites built with Canva and modern AI tools.",
    span: "md:col-span-4",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 } }),
};

export const Services = ({ onSelect }) => {
  return (
    <section id="services" data-testid="services-section" className="py-28 sm:py-40 bg-[#0A0A0A]">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-16 gap-6">
          <div>
            <p className="font-body text-xs uppercase tracking-[0.3em] text-gray-500 mb-4">What I Do</p>
            <h2 className="font-head uppercase text-4xl sm:text-6xl tracking-tighter text-white leading-none">
              Services<span className="text-[#D90429]">.</span>
            </h2>
          </div>
          <p className="font-body text-base text-gray-400 max-w-sm">
            Three disciplines, one cinematic language. Choose a lane and let&apos;s build something unforgettable.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5">
          {cards.map((c, i) => {
            const Icon = c.icon;
            return (
              <motion.button
                key={c.id}
                custom={i}
                variants={reveal}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-60px" }}
                data-testid={`service-card-${c.id}`}
                onClick={() => onSelect(c.id)}
                className={`group relative overflow-hidden text-left border border-white/10 ${c.span} ${
                  c.tall ? "min-h-[380px] md:min-h-[520px]" : "min-h-[380px] md:min-h-[250px]"
                }`}
              >
                <img
                  src={c.img}
                  alt={c.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/20" />
                <div className="relative h-full flex flex-col justify-between p-7">
                  <div className="flex items-center justify-between">
                    <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gray-300">
                      <Icon className="w-4 h-4 text-[#EF233C]" /> {c.label}
                    </span>
                    <ArrowUpRight className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300" />
                  </div>
                  <div>
                    <h3 className="font-head uppercase text-3xl sm:text-4xl tracking-tight text-white leading-none">
                      {c.title}
                    </h3>
                    <p className="font-body text-sm text-gray-300 mt-3 max-w-md">{c.desc}</p>
                  </div>
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
